export default __webpack_public_path__ + "static/australian-thermic-lance-logo-update-32f8bab819dc72e71fddb70f16b59ac7.mp4";